import { DEFAULT_CINEMA_HANDLER } from "~/utils/constants";
import { navigateTo } from "#imports";
import { useLastVisitedLocationCookie } from "~/composables/useLastVisitedLocationCookie";

export const useCinemaNavigation = () => {
  const isNavOpen = useState("isHeaderNavOpen", () => ({
    cinema: false,
    pages: false,
    login: false,
  }));

  const location = useLastVisitedLocationCookie();

  const openCinemaNav = () => {
    isNavOpen.value.cinema = true;
  };

  const closeCinemaNav = () => {
    isNavOpen.value.cinema = false;

    // Clear wasFirstVisit so the selector-close watcher in TheCinemaNavigation
    // doesn't redirect to the default cinema — any caller of this function has
    // already handled the destination (or is dismissing the modal themselves).
    const wasFirstVisit = useState("wasFirstVisit", () => false);
    wasFirstVisit.value = false;
  };

  const navigateToDefaultCinema = (callback = null) => {
    const lastVisitedLang = useCookie("lastVisitedLang");

    location.setValue({
      lang: lastVisitedLang.value,
      cinema: DEFAULT_CINEMA_HANDLER,
    });

    navigateTo(location.cookie.value);

    if (callback) {
      callback();
    }
  };

  const hasSomeCinemaLocation = () => {
    return location.has.value;
  };

  return {
    openCinemaNav,
    closeCinemaNav,
    hasSomeCinemaLocation,
    navigateToDefaultCinema,
  };
};
